
import LoadVue from "@/common/LoadVue";
export default new LoadVue().getVue();
